// extracted by mini-css-extract-plugin
export default {"popover":"BooleanInputPopover_popover__ntxrc","buttons":"BooleanInputPopover_buttons__SoHta","danger":"BooleanInputPopover_danger__BmmmO"};